import { h, Fragment } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import { Transition } from 'react-transition-group';

function getOptsForKey(programs, key) {
  return Object.keys(
    programs
    .map(f => f[key] || [])
    .reduce(
      (acc, opts) => [...acc, ...opts],
      []
    )
    .reduce(
      (acc, opt) => {
        if(typeof opt == "object"){
          opt = opt.name; // Handle certificate program filters
        }
        return Object.assign(acc, { [opt]: true })
      },
      {}
    )
  )
  .sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
}

function SidebarView (props) {
  const node = useRef();
  return (
    <div className="view-button-wrapper" ref={node}>
      <button className="filter__title view-button" onClick={props.handleViewButtonClick(props.title, props.target, true)}>
        {Drupal.t(props.title)}
      </button>
    </div>
  );
}

function SidebarFilter(props) {
  let opts = getOptsForKey(props.programs , props.target);

  const currentFilters = props.filters[props.target] || [];

  const handleOptionClick = (option) => () => {
    const active = currentFilters.indexOf(option) > -1;
    delete props.filters.view; // Always erase view filters whenever an option is clicked.

    if (active) {
      const newFilters = currentFilters.filter(i => i !== option);
      if (option === 'Music') {
        props.setFilters(Object.assign({}, props.filters, {
          [props.target]: newFilters,
          focus: []
        }));
      } else {
        props.setFilters(Object.assign({}, props.filters, {
          [props.target]: newFilters
        }));
      }
    } else {
      const newFilters = [
        ...currentFilters,
        option
      ];
      props.setFilters(Object.assign({}, props.filters, {
        [props.target]: newFilters
      }))
    }
  }

  const node = useRef();

  // Custom sort the items in "Arts Area"
  if(props.target == 'area'){
    const optsOrdered = [];

    opts.forEach( value => {
      let sorted = {
        value: value,
        weight: 100, // Random items get sorted last.
      };
      switch(value){
        case 'Music':
          sorted.weight = 10;
          break;
        case 'Creative Writing':
          sorted.weight = 20;
          break;
        case 'Theatre Arts':
          sorted.weight = 30;
          break;
        case 'Visual Arts':
          sorted.weight = 40;
          break;
        case 'Film and New Media':
          sorted.weight = 50;
          break;
        case 'Dance':
          sorted.weight = 60;
          break;
        case 'College Prep':
          sorted.weight = 70;
          break;
        case 'Interdisciplinary Arts':
          sorted.weight = 80;
          break;
      }
      optsOrdered.push(sorted);
    });

    // Flatten our array of objects back into a plain array.
    opts = optsOrdered.sort((a, b) => a.weight > b.weight).map((el) => el.value);

  }


  if (props.target == 'grade') {
    const optsOrdered = [];

    opts.forEach(value => {
      let sorted = {
        value: value,
        weight: 100, // Random items get sorted last.
      };
      switch (value) {
        case "Adult (Ages 18+)":
          sorted.weight = 10;
          break;
        case "Teens (Grades 6-12)":
          sorted.weight = 20;
          break;
        case "Kids (Grades 2-5)":
          sorted.weight = 30;
          break;
      }
      optsOrdered.push(sorted);
    });

    // Flatten our array of objects back into a plain array.
    opts = optsOrdered.sort((a, b) => a.weight > b.weight).map((el) => el.value);

    if (props.mode === 'certificates') {
      opts = opts.filter(opt => opt !== 'Kids (Grades 2-5)');
    }

  }


  const strToId = (str) => {
    return str.toLowerCase().replace(/\W{1,}/g, '-');
  };


    return (
      <div ref={node}>
        {props.title.length > 0 &&
         <p className="filter__title">{Drupal.t(props.title)}</p>
        }

        {opts.map((opt, idx) => (
          <div className='filter__item'>
            <label for={strToId('input-sb-' + opt)} class="filter__label" onChange={handleOptionClick(opt)}>
              <input id={strToId('input-sb-' + opt)} type="checkbox" checked={currentFilters.indexOf(opt) > -1} />
              <span class="filter__checkbox">{Drupal.t(opt)}</span>
            </label>
            {
              opt === 'Music'
              &&
              <Transition in={currentFilters.indexOf(opt) > -1} timeout={500}>
                {
                  state => {
                    const animate = (() => {
                      if (state === 'exited') return 'hidden__filter__item__num__';
                      if (state === 'entered') return 'filter__item__num__';
                      if (state === 'exiting') return 'hide__filter__item__num__';
                      if (state === 'entering') return 'show__filter__item__num__';
                    })();

                    return <SidebarFilter
                      {...props}
                      animate={animate}
                      title=""
                      target="focus"
                    />
                  }
                }
              </Transition>
            }
          </div>
        ))}

      </div>
    );
}

export default function Sidebar(props) {
  const isCertificateMode = props.mode === 'certificates';

  return (
    <div className="filter__sidebar">
      {!isCertificateMode &&
        <>
          <div class="view-by">
            {Drupal.t("View By")}
          </div>
          <SidebarView title={Drupal.t("All")} target="view" type="view" {...props} />
          <SidebarView title={Drupal.t("Popular")} target="view" type="view" {...props} />
          <SidebarView title={Drupal.t("New")} target="view" type="view" {...props} />
        </>
      }
      <div class="filter-by">
        {Drupal.t("Filter By")}
      </div>
      <SidebarFilter title={Drupal.t("Area Of Study")} target="area" {...props} />
      <SidebarFilter title={Drupal.t("Age Range")} target="grade" {...props} />
      {!isCertificateMode &&
        <SidebarFilter title={Drupal.t("Program Type")} target="duration" {...props} />
      }
    </div>
  );
}
